import type { SortDir } from '../hooks/useSortable.js';

interface Props<K extends string> {
  label: string;
  sortKey: K;
  activeSortKey: K;
  sortDir: SortDir;
  onSort: (key: K) => void;
  right?: boolean;
}

export function SortableTh<K extends string>({ label, sortKey, activeSortKey, sortDir, onSort, right }: Props<K>) {
  const active = sortKey === activeSortKey;
  return (
    <th
      className={`px-5 py-3 text-xs font-semibold uppercase tracking-wider text-text-secondary select-none cursor-pointer hover:text-text-primary transition-colors ${right ? 'text-right' : 'text-left'}`}
      onClick={() => onSort(sortKey)}
    >
      <span className="inline-flex items-center gap-1">
        {right && active && <span className="text-[10px] opacity-60">{sortDir === 'asc' ? '↑' : '↓'}</span>}
        {label}
        {!right && active && <span className="text-[10px] opacity-60">{sortDir === 'asc' ? '↑' : '↓'}</span>}
      </span>
    </th>
  );
}
